<template>
  <section class="case-creation" v-loading="loading">
    <div class="case-creation__step case-creation__billing-information">
      <div class="case-creation__card">
        <div class="case-creation__heading">
          <div class="title-with-icon">
            <span class="icon">
              <img
                src="@/assets/images/icons/icon-billing-info.svg"
                alt="icon"
                class="img-fluid"
              />
            </span>
            <h3 class="title">Billing</h3>
          </div>
          <div>
            <div
              class="sent-billing-info"
              v-if="
                this.getCaseInformation &&
                this.getCaseInformation.billing_application_sent_status
              "
            >
              Claim Sent To Billing Application :
              {{
                this.getCaseInformation.billing_application_sent_on
                  ? momentWithTimezone(
                      this.getCaseInformation.billing_application_sent_on,
                      "MM-DD-yyyy hh:mm A"
                    )
                  : "--"
              }}
            </div>
          </div>
          <div class="right-align">
            <div
              class="delete-billing-info"
              v-if="showSendToRxnt || showSendToRxntOther"
            >
              <el-button
                v-if="
                  this.getCaseInformation &&
                  this.getCaseInformation.billing_application_sent_status
                "
                title="Resend To RXNT"
                @click="sentToRXNT()"
                type="danger"
              >
                RESEND TO RXNT
              </el-button>
              <el-button
                v-else
                title="Send To RXNT"
                @click="sentToRXNT()"
                type="danger"
              >
                SEND TO RXNT
              </el-button>
            </div>
          </div>
        </div>
        <div class="case-creation__body padding-0">
          <div class="billing-information-tabs-view">
            <el-row :gutter="30">
              <el-col :xl="24" :lg="24">
                <div class="input-value view-cases">
                  <h4 class="name">Coding Notes</h4>
                  <p
                    class="value"
                    v-if="
                      this.getCaseInformation &&
                      this.getCaseInformation.billing_notes
                    "
                  >
                    {{ this.getCaseInformation.billing_notes }}
                  </p>
                  <p class="value" v-else>--</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      loading: false,
      case_id: "",
    };
  },
  mixins: [UserPermissionsHelper],
  mounted() {
    if (this.$route.params.case_id) {
      this.case_id = this.$route.params.case_id;
    }
  },
  computed: {
    ...mapGetters("cases", ["getCaseInformation", "getRXNTSendStatus"]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    showSendToRxnt() {
      let { billing_info, billing_type, status, billing_status } = this.getCaseInformation || {};
      let insurance = billing_info && billing_info.insurance;

      // Check for any insurance-related info
      let hasInsurance = insurance && (
        insurance.primary_insurance ||
        insurance.secondary_insurance ||
        insurance.tertiary_insurance ||
        insurance.guarantor
      );

      // Valid billing types
      let validBillingTypes = ['INSURANCE'];

      // Valid billing statuses
      let validBillingStatuses = [
        'Billed',
        'Billed with Exception',
        'Client',
        'client',
        'Coding',
        'Exception',
        'On hold',
        'Patient',
        'billed',
        'billed with exception',
        'coding',
        'exception',
        'on hold',
        'patient', 
        'Unbilled',
        'unbilled',
        'Exception Reviewed',
        'exception reviewed',
        'Client bill',
        'client bill'
      ];

      let cleanBillingType = billing_type ? billing_type.trim() : '';
      let cleanBillingStatus = billing_status ? billing_status.trim() : '';

      return(
      hasInsurance &&
      validBillingTypes.includes(cleanBillingType) &&
      status === 'COMPLETE' &&
      !this.isBillingUser &&
      validBillingStatuses.includes(cleanBillingStatus));
    },
    showSendToRxntOther() {
      let { billing_type, status, billing_status } = this.getCaseInformation || {};

      // Valid billing types
      let validBillingTypes = ['PATIENT', 'CLIENT', 'SENDOUT','LABCORP','LABCORP/SENDOUT'];

      // Valid billing statuses
      let validBillingStatuses = [
        'Billed',
        'Billed with Exception',
        'Client',
        'client',
        'Coding',
        'Exception',
        'On hold',
        'Patient',
        'billed',
        'billed with exception',
        'coding',
        'exception',
        'on hold',
        'patient', 
        'Unbilled',
        'unbilled',
        'Exception Reviewed',
        'exception reviewed',
        'Client bill',
        'client bill'
      ];

      let cleanBillingType = billing_type ? billing_type.trim() : '';
      let cleanBillingStatus = billing_status ? billing_status.trim() : '';

      return(
      validBillingTypes.includes(cleanBillingType) &&
      status === 'COMPLETE' &&
      !this.isBillingUser &&
      validBillingStatuses.includes(cleanBillingStatus));
    },
  },
  methods: {
    async sentToRXNT() {
      this.loading = true;
      try {
        let params = {
          case_id: this.case_id,
        };
        await this.$store.dispatch("cases/sendAccessionToRXNT", params);
        if (this.getRXNTSendStatus) {
          successNotification("Order sent to RXNT successfully");
          window.location.reload();
        } else {
          if (!this.getErrors || this.getError) {
            errorNotification(
              this.getError || "Error while sending order to RXNT"
            );
          }
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss">
.case-creation__billing-information {
  .delete-billing-info {
    margin-right: 20px;
    padding: 5px 0;

    button {
      background: #f24a55;
      min-height: 25px;
      border: none;
      padding: 5px 20px;
    }
  }
  .sent-billing-info {
    margin-right: 40px;
    padding: 5px 0;
    color: blue;
  }
  .case-creation__body {
    &.padding-0 {
      padding: 0 !important;
    }
    .billing-information-tabs-view {
      padding: 20px 20px 0;
    }
  }
}
</style>
